var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "选择执行人",
        visible: _vm.staffDialogVisible,
        width: "720px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.staffDialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "staff-box" },
        [
          _c(
            "div",
            { staticClass: "search-member" },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入员工姓名或部门名称" },
                model: {
                  value: _vm.loginName,
                  callback: function ($$v) {
                    _vm.loginName = $$v
                  },
                  expression: "loginName",
                },
              }),
              _c("img", {
                attrs: { src: require("@/assets/gbIcon/search_icon.png") },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.searchEmployee.apply(null, arguments)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.waiting,
                  expression: "waiting",
                },
              ],
              staticClass: "table-box",
            },
            [
              _c(
                "el-table",
                {
                  ref: "singleTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.list.subaccountData, innerpage: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { width: "46" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-radio", {
                              attrs: { label: scope.$index },
                              nativeOn: {
                                change: function ($event) {
                                  return _vm.getCurrentRow(scope.row)
                                },
                              },
                              model: {
                                value: _vm.radio,
                                callback: function ($$v) {
                                  _vm.radio = $$v
                                },
                                expression: "radio",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "employeeName", label: "成员信息" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "emInfor" }, [
                              _c("img", {
                                staticClass: "imgUrl",
                                attrs: { src: scope.row.avatarUrl, alt: "" },
                              }),
                              _c(
                                "div",
                                { staticClass: "box" },
                                [
                                  scope.row.employeeName
                                    ? [
                                        scope.row.employeeName.length > 16
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "light",
                                                  content:
                                                    scope.row.employeeName,
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class: [
                                                      "emName",
                                                      "textOverflow",
                                                      scope.row.leaderInDept ==
                                                      1
                                                        ? "emLd"
                                                        : "",
                                                    ],
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.employeeName
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                class: [
                                                  "emName",
                                                  "textOverflow",
                                                  scope.row.leaderInDept == 1
                                                    ? "emLd"
                                                    : "",
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.employeeName)
                                                ),
                                              ]
                                            ),
                                      ]
                                    : _c("span", [_vm._v(_vm._s("--"))]),
                                  scope.row.leaderInDept == 1
                                    ? _c("i", [_vm._v("上级")])
                                    : _vm._e(),
                                  scope.row.phoneNumber
                                    ? _c("span", { staticClass: "emPhone" }, [
                                        _vm._v(_vm._s(scope.row.phoneNumber)),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "loginName",
                      label: "账号",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.loginName
                              ? [
                                  scope.row.loginName.length > 20
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "light",
                                            content: scope.row.loginName,
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "textOverflow" },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.loginName)
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "textOverflow" },
                                        [_vm._v(_vm._s(scope.row.loginName))]
                                      ),
                                ]
                              : _c("span", [_vm._v(_vm._s("--"))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "departmentNames", label: "部门" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.departmentNames
                              ? [
                                  scope.row.departmentNames.length > 11
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "light",
                                            content: scope.row.departmentNames,
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "textOverflow" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.departmentNames
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "textOverflow" },
                                        [
                                          _vm._v(
                                            _vm._s(scope.row.departmentNames)
                                          ),
                                        ]
                                      ),
                                ]
                              : _c("span", [_vm._v(_vm._s("--"))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "position",
                      label: "职务",
                      align: "center",
                      width: "83",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.position
                              ? [
                                  scope.row.position.length > 4
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "light",
                                            content: scope.row.position,
                                            placement: "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "textOverflow" },
                                            [_vm._v(_vm._s(scope.row.position))]
                                          ),
                                        ]
                                      )
                                    : _c("span", [
                                        _vm._v(_vm._s(scope.row.position)),
                                      ]),
                                ]
                              : _c("span", [_vm._v(_vm._s("--"))]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.list.subaccountData.length
            ? _c("pagination", {
                key: _vm.list.pageNum,
                attrs: {
                  pageNum: _vm.list.pageNum,
                  pageSize: _vm.list.pageSize,
                  total: _vm.list.total,
                },
                on: {
                  sizeChange: _vm.handleSizeChange,
                  currentChange: _vm.handleCurrentChange,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "dialog-cancel", size: "small", w88: "" },
              on: {
                click: function ($event) {
                  _vm.staffDialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "pure", size: "small", w88: "" },
              on: { click: _vm.choiceOperator },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }